import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { useLanguage } from '../context/LanguageContext';

const NotFound: React.FC = () => {
  const { t } = useLanguage();

  return (
    <div className="bg-maat-stone min-h-[70vh] flex items-center justify-center px-6 py-32">
      <div className="text-center max-w-xl">
        <p className="text-7xl md:text-9xl font-serif text-maat-gold mb-6 leading-none">404</p>
        <h1 className="text-3xl md:text-4xl font-serif text-maat-blue mb-4">{t.notFound.title}</h1>
        <p className="text-lg text-maat-blue/70 mb-10 leading-relaxed">{t.notFound.subtitle}</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 bg-maat-blue text-maat-stone px-8 py-4 rounded-3xl font-bold hover:bg-maat-gold hover:text-maat-blue transition-all duration-300 shadow-lg transform hover:-translate-y-1"
        >
          <ArrowLeft size={18} /> {t.notFound.cta}
        </Link>
      </div>
    </div>
  );
};

export default NotFound;
